import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const HelmetContext = createContext();

const HelmetProvider = props => {
  const { children } = props;
  const [title, setTitleState] = useState('GAZE');
  const [description, setDescriptionState] = useState('GAZE шоурум і онлайн-магазин');
  const [image, setImageState] = useState('');
  const [url, setUrlState] = useState(
    typeof window !== 'undefined' ? window.location.href : ''
  );

  const setTitle = useCallback(
    newTitle => setTitleState(newTitle || 'GAZE'),
    []
  );

  const setDescription = useCallback(
    newDescription => setDescriptionState(newDescription || 'GAZE шоурум і онлайн-магазин'),
    []
  );

  const setImage = useCallback(
    newImage => setImageState(newImage || ''),
    []
  );

  const setUrl = useCallback(
    newUrl => setUrlState(newUrl || (typeof window !== 'undefined' ? window.location.href : '')),
    []
  );

  const pageTitle = title ? `GAZE | ${title}` : 'GAZE';

  return useMemo(() => (
    <HelmetContext.Provider value={{ setTitle, setDescription, setImage, setUrl }}>
      <Helmet htmlAttributes={{ lang: 'uk' }}>
        <meta charSet="utf-8" />
        <title>{pageTitle}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={url} />
        <meta property="og:site_name" content="GAZE" />
        <meta property="og:locale" content="uk_UA" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={url} />
        {image ? <meta property="og:image" content={image} /> : null}
        <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={description} />
        {image ? <meta name="twitter:image" content={image} /> : null}
      </Helmet>
      {children}
    </HelmetContext.Provider>
  ), [setTitle, setDescription, setImage, setUrl, pageTitle, description, image, url, children]);
};

HelmetProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default HelmetProvider;

export const useHelmet = ({ title, description, image, url } = {}) => {
  const { setTitle, setDescription, setImage, setUrl } = useContext(HelmetContext);

  useEffect(() => {
    setTitle(title);
    setDescription(description);
    setImage(image);
    setUrl(url || (typeof window !== 'undefined' ? window.location.href : ''));
  }, [description, image, setDescription, setImage, setTitle, setUrl, title, url]);
};
